module.exports = "<p>assets-management works!</p>\n"